import React from 'react';
import useSWRMutation from 'swr/mutation';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import IconAction from '#app/Component/IconAction';
import { generateApiPath, writeItem } from '#app/Handler/api';
import { Filters } from '#app/View/InventoryManagement/Deposit/Picking';
import DepositByProductEntryPoints from '#app/entrypoints/depositByProduct';
import { useCollectionPaginated } from '#app/hooks/useCollectionPaginated';
import { DepositByProductPicking } from '#app/typings/depositByProduct';

type Props = Pick<ReturnType<typeof useCollectionPaginated<DepositByProductPicking, Filters>>, 'mutate'> & {
  id: string;
};

const ActionRemove: React.FC<Props> = ({ id, mutate }) => {
  const { trigger: remove } = useSWRMutation(
    generateApiPath(DepositByProductEntryPoints.editPicking, { id }),
    writeItem('DELETE'),
  );

  const handleRemove = async (): Promise<void> => {
    try {
      await remove();
      dispatch(
        SnackbarOpen({
          text: 'Emplacement supprimé avec succès.',
          variant: 'success',
        }),
      );
      mutate();
    } catch {
      dispatch(
        SnackbarOpen({
          text: "Une erreur inattendue s'est produite.",
          variant: 'error',
        }),
      );
    }
  };

  return <IconAction title="Supprimer" icon="delete" onClick={handleRemove} />;
};

export default ActionRemove;
